/* Colour-aware product media gallery.

   Liquid lays the gallery out for the selected colour (see
   product-media-gallery.liquid). This keeps it in step when the shopper
   changes variant.

   1. Swap the gallery when the colour changes. The theme already fetches the
      whole re-rendered section on every variant change and broadcasts it on
      the variantChange pubsub event, so this reuses that HTML rather than
      making a second request. The new gallery is initialised straight away,
      because the theme otherwise waits for it to scroll into view, and it
      opens on the slide the shopper was looking at. A colour's versions sit
      in the same slots, so that is the same view in the new colour.

   2. Switch off the theme's own jump to the variant's image. It jumps to
      variant.featured_media.position, the image's place in the admin order,
      which no longer matches the gallery once other colours' versions are
      left out. On desktop it would also move that image to the top of the
      grid and scroll to it. */
(function () {
  /* Patch the prototype rather than each instance, so a gallery swapped in on
     a colour change is covered too. */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(function () {
      var ctor = customElements.get('media-gallery');
      if (!ctor || !ctor.prototype || ctor.prototype.__kmPatched) return;
      ctor.prototype.__kmPatched = true;
      ctor.prototype.setActiveMedia = function () {};
    });
  }

  function currentSlide(gallery) {
    var slider = gallery.sliderInstance && gallery.sliderInstance.slider;
    return slider ? slider.activeIndex || 0 : 0;
  }

  function swapGallery(payload) {
    var data = payload && payload.data;
    if (!data || !data.html || !data.sectionId) return;

    var id = 'MediaGallery-' + data.sectionId;
    var current = document.getElementById(id);
    var next = data.html.getElementById(id);
    if (!current || !next) return;

    // A size change within one colour produces identical markup; skip the churn.
    if (current.innerHTML.trim() === next.innerHTML.trim()) return;

    var index = currentSlide(current);
    current.replaceWith(next);
    if (typeof next.init !== 'function') return;

    try {
      next.init();
      var slider = next.sliderInstance && next.sliderInstance.slider;
      if (!slider || index === 0) return;
      if (index >= next.initialMediaLimit && typeof next.ensureDeferredLoaded === 'function') {
        next.ensureDeferredLoaded();
      }
      slider.slideTo(Math.min(index, slider.slides.length - 1), 0, false);
      if (typeof next.syncThumbsPosition === 'function') next.syncThumbsPosition();
    } catch (e) {
      /* the gallery still renders; it just opens on the cover */
    }
  }

  function init() {
    if (!window.FoxTheme || !FoxTheme.pubsub || !FoxTheme.pubsub.PUB_SUB_EVENTS) return false;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, swapGallery);
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
